import React, {Component} from 'react';
import styled from "styled-components";
import {SERVICE_TYPES} from "../constants/ServiceTypes";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {DETAILED_CALL_URL} from "../constants/URLS";
import {TakeCallButton} from "./Buttons";
import Moment from "react-moment";
import 'moment/locale/hu';
import {distanceFromCoords} from "../utils/DistanceFromCoords";

const CallItemDiv = styled.div`
width: 80%;
border: ${props => props.active ? "2px solid #70A3F1" : "2px solid #333333"};
background-color: ${props => props.active ? "#70A3F1" : "transparent"};
color: ${props => props.active ? "#ffffff" : "#333333"};
border-radius: 20px;
margin: 2rem auto;
display: block;
box-sizing: border-box;
height: 12rem;
position: relative;
`

export const StatusIndicator = styled.div`
width: 10px;
height: 10px;
border-radius: 50%;
background-color: ${props => props.active ? "#0cc235" : "#ce2424"};
display: inline-block;
position: absolute;
top: .9rem;
right: 1rem;
`

class CallListItem extends Component {
    render() {
        //console.log(this.props)
        const {data, callId} = this.props
        //console.log(data)
        return (
            <CallItemDiv onClick={() => {
                //console.log(data.id)
                this.props.history.push(DETAILED_CALL_URL + callId)
            }}>
                <div style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    display: 'inline-block',
                    padding: '2rem 1rem 1rem 0',
                    boxSizing: 'border-box',
                    textAlign: 'justify',
                    textAlignLast: 'left',
                }}>
                    <div>
                        <h5 style={{
                            margin: '0 0 .3rem',
                            position: 'absolute',
                            top: '0.7rem',
                            left: '50%',
                            transform: 'translate(-50%, 0)'
                        }}>
                            {SERVICE_TYPES[Number(data.info[1].service)].name}
                        </h5>
                        <StatusIndicator active={data.active}/>
                    </div>


                    <span>Cim: {data.info[0].address.formatted_address}</span>
                    <span>Nev: {data.info[6].lastN} {data.info[6].firstN}</span>

                    {data.taken ?
                        <div>
                            <button onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                const url = `
                        https://www.google.com/maps/dir/?api=1&\
destination=${data.coordinates.latitude},${data.coordinates.longitude}&\
travelmode=driving\
                        `
                                window.open(url, '_blank')
                            }}>Navigate
                            </button>
                        </div>
                        :
                        <div>
                            <TakeCallButton id={data.id}/>
                        </div>
                    }
                    <Moment
                        fromNow
                        locale={'hu'}
                        interval={0}
                        //format={"LLL"}
                    >{new Date(data.callDate.seconds * 1000)}</Moment>
                    {/*
                    <div>{data.taken ? 'taken already' : 'not taken yet'}</div>
*/}
                    <div>CallID: {callId}</div>

                    {typeof data.takenBy === "object" ?
                        <div>EmployeeName: {data.takenBy.lastN} {data.takenBy.firstN}</div>
                        :
                        null
                    }
                    {this.props.myCoords && this.props.myCoords.lat && this.props.myCoords.lng ?
                        <div>Distance: {
                            Math.ceil(distanceFromCoords(
                                Number(data.coordinates.latitude),
                                Number(data.coordinates.longitude),
                                Number(this.props.myCoords.lat),
                                Number(this.props.myCoords.lng),
                            ) * 1.15)
                        } km</div>
                        :
                        null
                    }
                    {this.props.isCompany ?
                        <div>
                            {this.props.takenBy ?
                                <div>{this.props.takenBy.firstN} {this.props.takenBy.lastN}</div>
                                :
                                <div>Not taken yet</div>
                            }
                        </div>
                        :
                        null
                    }
                </div>
            </CallItemDiv>
        );
    }
}

export default compose(
    withRouter
)(CallListItem);